import axios from "axios";
import {store} from '../store/store'
import { logout } from "../slices/authSlice"; // your logout action
import { toast } from "react-toastify";

let isLoggingOut = false;

axios.interceptors.response.use(
  (response) => response,

  (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.message;

    if (
      !isLoggingOut &&
      status === 401 &&
      (message === "Invalid session" || message === "Session expired")
    ) {
      isLoggingOut = true;

      // Clear redux
      store.dispatch(logout());

      // Clear local storage/session storage if you use them
      localStorage.clear();
      sessionStorage.clear();

      toast.error("Your session has expired. Please log in again.");

      setTimeout(() => {
        window.location.replace("/");
      }, 1500);
    }

    return Promise.reject(error);
  }
);